export const API_BASE = import.meta.env.PROD
  ? 'https://edgerelay-api.ghwmelite.workers.dev/v1'
  : '/v1';
